import { mapServerSideUser } from '@/utils/api.mapper'
import { getInstance } from '@/utils/axios'
import { ApiError } from '@/utils/axios.interceptors'
import { User } from './types'

export interface LoginRequest {
  email: string
  password: string
}

export interface LoginResponse {
  user: User
  token: {
    accessToken: string
  }
}

export interface RegisterRequest {
  firstName: string
  lastName: string
  middleName: string
  email: string
  password: string
  passwordConfirmation: string
  phoneNumber: string
  positionId: string
  gender: string
}

export interface RegisterResponse {
  user: User
  token: {
    accessToken: string
  }
}

export const login = async (request: LoginRequest): Promise<LoginResponse> => {
  const { data } = await getInstance().post('api/auth/login', request)

  if (!data.access_token) {
    throw new ApiError()
  }

  return {
    token: {
      accessToken: data.access_token,
    },
    user: mapServerSideUser(data.user),
  }
}

export const register = async (request: RegisterRequest): Promise<RegisterResponse> => {
  const { data } = await getInstance().post('api/auth/login', {
    first_name: request.firstName,
    last_name: request.lastName,
    middle_name: request.middleName,
    email: request.email,
    password: request.password,
    password_confirmation: request.passwordConfirmation,
    phone_number: request.phoneNumber,
    position_id: request.positionId,
    gender: request.gender,
  })

  return {
    user: mapServerSideUser(data.user),
    token: {
      accessToken: data.access_token,
    },
  }
}
